export default __webpack_public_path__ + "static/media/hbs-cbb-banner-2.9d129573.jpg";